import React, { FunctionComponent, useEffect, useState } from "react";
import "./style.scss";
import axios from "axios";
import IChangeLog from "../../interfaces/api/IChangeLog";

const ChangeLogPage: FunctionComponent = () => {
    const [data, setData] = useState<IChangeLog | null>(null);

    useEffect(() => {
        getChageLogs();
    }, []);

    const getChageLogs = async () => {
        try {
            const r = await axios.get<IChangeLog>("https://api.timinator.app/version/latest");
            setData(r.data);
        }
        catch(e) {
        }
    }

    return <div className="ChangeLogPage">
        <div className="content">
            <h1>Change Log</h1>
            <div className="blocks">
                <div className="block">
                    <h3>{data?.version || ""}</h3>
                    <div className="text">{data?.comment || ""}</div>
                    <ul>
                        {data?.changes?.map((x, i) => <li key={`logs-${i}`}>{x}</li>)}
                    </ul>
                </div>
            </div>
        </div>
    </div>
}

export default ChangeLogPage;